import React from 'react';
import { Button, Spin } from "antd";
import Login from "../../Login/Login";

import IFrame from "../../IFrame";

const ChannelPreview = ( {channelId, claims, onSourceReady, showChat, loadingPlayer, setStateHandler} ) => {
  const player = `https://www.ustream.tv/embed/${channelId}?html5ui&autoplay=true`;
  const chat = `https://www.ustream.tv/socialstream/${channelId}`;

  const updateObj = showChat ?
  { showChat: false } : { showChat: true };

  return (
    <div>
      {
        claims ? (
          <div className="watch-container">
            <div className="player-container">
              <IFrame className="player" url={player} onload={onSourceReady} title="player"/>
            </div>
            <div className="chat-controles">
              <Button
                className="chat-button"
                name={showChat ? "hideChat" : "showChat"}
                onClick={() => setStateHandler(updateObj)}
              >
                {showChat ? "Hide chat" : "Show chat"}
              </Button>
              <div className={`chat-wrapper ${showChat ? '' : 'hidden'}`}>
                <IFrame className="chat" url={chat} title="chat"/>
              </div>
            </div>
            <div className={`preloader-wr ${loadingPlayer ? '' : 'hidden' }`}>
              <Spin className="preloader" />
            </div>
          </div>
        ) : (
          <div className="login-required">
            <Login/>
          </div>
        )
      }
    </div>
  )
}

export default ChannelPreview;



// WEBPACK FOOTER //
// ./src/components/Modules/ChannelPreview/index.js